import React from 'react';
import { FaTrashAlt } from 'react-icons/fa';

import  ButtonDownload from '../ButtonDownload'

const Liquidation = ({element, isAdmin, eventDownloadLiquidation, eventDeleteLiquidation}) => {
    return ( 
        <tr>
            <td className="text-center">{element.period.name}</td>
            <td className="text-center">{element.description}</td>
            <td className="text-center">
                <ButtonDownload 
                    obj={element.file}
                    downloadMethod={eventDownloadLiquidation}
                    nameKey={'file'}
                    type={'application/pdf'}
                />
            </td>
            {!isAdmin? null :
                <td className="text-center">
                    <button className="btn btn-link" 
                    onClick={()=>eventDeleteLiquidation(element.id)}
                    >
                        <FaTrashAlt className="text-danger" />
                    </button>                    
                </td>
            }
        </tr>
     );
}
 
export default Liquidation;